import { useEffect, useState } from "react";
import appErrorToast from "../components/common/AppErrorToast";
import { getYouTrackProjects, IYouTrackProjectOption } from "../services/youtrackProjects.service";

/** Gets the list of YouTrack projects when the dialog is opened (e.g. assignment / edit). */
export function useYouTrackProjectsWhenOpen(open: boolean): IYouTrackProjectOption[] {
  const [projects, setProjects] = useState<IYouTrackProjectOption[]>([]);

  useEffect(() => {
    if (!open) {
      return;
    }
    getYouTrackProjects()
      .then(setProjects)
      .catch(() => {
        appErrorToast("Nie udało się pobrać listy projektów YouTrack.");
      });
  }, [open]);

  return projects;
}
